import script from "./catalogMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./catalogMenu.vue?vue&type=script&setup=true&lang=ts"

import "./catalogMenu.vue?vue&type=style&index=0&id=a9319d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9319d8c"]])

export default __exports__